// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2ByWH","log":"ModalInventoryLogs_log__27PIq","date":"ModalInventoryLogs_date__1PePA","userName":"ModalInventoryLogs_userName__3huXa"};